import { createSlice } from '@reduxjs/toolkit';
import { actionLabelsFetch } from './actions';

interface State {
  isLoading: boolean;
  isInit: boolean;
}

const initialState = (): State => ({
  isLoading: false,
  isInit: false,
});

const slice = createSlice({
  name: 'LABELS',
  initialState,
  reducers: {},
  extraReducers(build) {
    build
      .addCase(actionLabelsFetch.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(actionLabelsFetch.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isInit = true;
      })
      .addCase(actionLabelsFetch.rejected, (state, action) => {
        state.isLoading = false;
        state.isInit = true;
      });
  },
});

export const labelsReducer = slice.reducer;
